// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Graph Engine API
 * HTTP API for managing Neo4j graph engines.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelsGraphEngineState } from './ModelsGraphEngineState';
import {
  ModelsGraphEngineStateFromJSON,
  ModelsGraphEngineStateFromJSONTyped,
  ModelsGraphEngineStateToJSON,
  ModelsGraphEngineStateToJSONTyped,
} from './ModelsGraphEngineState';

/**
 *
 * @export
 * @interface ModelsGraphEngineStatus
 */
export interface ModelsGraphEngineStatus {
  /**
   *
   * @type {string}
   * @memberof ModelsGraphEngineStatus
   */
  appliedNeo4jVersion?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsGraphEngineStatus
   */
  dnsName?: string;
  /**
   *
   * @type {string}
   * @memberof ModelsGraphEngineStatus
   */
  errorDetail?: string;
  /**
   *
   * @type {ModelsGraphEngineState}
   * @memberof ModelsGraphEngineStatus
   */
  state?: ModelsGraphEngineState;
}

/**
 * Check if a given object implements the ModelsGraphEngineStatus interface.
 */
export function instanceOfModelsGraphEngineStatus(
  value: object,
): value is ModelsGraphEngineStatus {
  return true;
}

export function ModelsGraphEngineStatusFromJSON(
  json: any,
): ModelsGraphEngineStatus {
  return ModelsGraphEngineStatusFromJSONTyped(json, false);
}

export function ModelsGraphEngineStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ModelsGraphEngineStatus {
  if (json == null) {
    return json;
  }
  return {
    appliedNeo4jVersion:
      json['appliedNeo4jVersion'] == null
        ? undefined
        : json['appliedNeo4jVersion'],
    dnsName: json['dnsName'] == null ? undefined : json['dnsName'],
    errorDetail: json['errorDetail'] == null ? undefined : json['errorDetail'],
    state:
      json['state'] == null
        ? undefined
        : ModelsGraphEngineStateFromJSON(json['state']),
  };
}

export function ModelsGraphEngineStatusToJSON(
  json: any,
): ModelsGraphEngineStatus {
  return ModelsGraphEngineStatusToJSONTyped(json, false);
}

export function ModelsGraphEngineStatusToJSONTyped(
  value?: ModelsGraphEngineStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    appliedNeo4jVersion: value['appliedNeo4jVersion'],
    dnsName: value['dnsName'],
    errorDetail: value['errorDetail'],
    state: ModelsGraphEngineStateToJSON(value['state']),
  };
}
